var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6253 17.7083H20.8337L19.3702 16.2449C18.9733 15.848 18.7503 15.3097 18.7503 14.7484V11.4583C18.7503 8.73705 17.0111 6.42197 14.5837 5.56397V5.20833C14.5837 4.05774 13.6509 3.125 12.5003 3.125C11.3497 3.125 10.417 4.05774 10.417 5.20833V5.56397C7.98951 6.42197 6.25033 8.73705 6.25033 11.4583V14.7484C6.25033 15.3097 6.02735 15.848 5.63046 16.2449L4.16699 17.7083H9.37533M15.6253 17.7083V18.75C15.6253 20.4759 14.2262 21.875 12.5003 21.875C10.7744 21.875 9.37533 20.4759 9.37533 18.75V17.7083M15.6253 17.7083H9.37533",
    stroke: "#3F3F46",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.c10c537eda77434359073d74692684e8.svg";
export { ForwardRef as ReactComponent };